import { render, staticRenderFns } from "./SystemSettingItem.vue?vue&type=template&id=7774d875&scoped=true"
import script from "./SystemSettingItem.vue?vue&type=script&lang=js"
export * from "./SystemSettingItem.vue?vue&type=script&lang=js"
import style0 from "./SystemSettingItem.vue?vue&type=style&index=0&id=7774d875&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7774d875",
  null
  
)

export default component.exports